import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
import { Link } from 'react-router-dom';

import { loadProviderCodes, generatePatientCode } from './api';
import defaultUserIcon from '../../../img/user/icon-user-default.png';
import { API_URL } from '../../config/constants';
import InvitePatientModal from './InvitePatientModal';
import AboutModal from './AboutModal';

const DropdownMenu = ({ user, appSocket }) => {
	const [isInvitePatientModalOpen, setInvitePatientModalOpen] = useState(false);
	const [isGeneratingCode, setGeneratingCode] = useState(false);
	const [inviteCode, setInviteCode] = useState(null);
	const [providersWithCodes, setProvidersWithCodes] = useState([]);
	const [isAboutModalOpen, setAboutModalOpen] = useState(false);
	const [connected, setConnected] = useState(appSocket.connected);

	const { id, name_first, name_last, profile_image_name } = user.toJSON();

	useEffect(() => {
		appSocket.on('connect', () => {
			setConnected(true);
			// appSocket.emit(
			// 	'authenticate',
			// 	{
			// 		/* TODO */
			// 	},
			// 	({ authenticated }) => {
			// 		app.user.set('authenticated', authenticated);
			// 	}
			// );
		});
		appSocket.on('disconnect', () => {
			setConnected(false);
		});
		user.on('sync', () => {
			// TODO force update
		});
		return () => {
			user.off('sync');
			appSocket.off('connect');
			appSocket.off('disconnect');
		};
	}, []);

	let picPath = '';

	const handleShowPatientInviteModal = async (event) => {
		event.preventDefault();
		try {
			const { data } = await loadProviderCodes(user.get('id'));
			setInvitePatientModalOpen(true);
			setInviteCode(null);
			setProvidersWithCodes(data.status);
		} catch (e) {
			setInvitePatientModalOpen(false);
			setInviteCode(null);
		}
	};

	const handleCloseInvitePatientModal = () => {
		setInvitePatientModalOpen(false);
		setInviteCode(null);
	};

	const handleGenerateCode = async (patientInfo) => {
		setGeneratingCode(true);
		try {
			const result = await generatePatientCode(user.get('id'), patientInfo);
			setInviteCode(result);
			setGeneratingCode(false);
		} catch (e) {
			setGeneratingCode(false);
		}
	};

	const handleOpenAboutModal = (event) => {
		event.preventDefault();
		setAboutModalOpen(true);
	};

	if (isEmpty(profile_image_name)) {
		picPath = defaultUserIcon;
	} else {
		picPath = `${API_URL}/provider_profile_images/${id}/download/${profile_image_name}`;
	}

	return (
		<>
			<InvitePatientModal
				isOpen={isInvitePatientModalOpen}
				onCancel={handleCloseInvitePatientModal}
				onGenerateCode={handleGenerateCode}
				isGeneratingCode={isGeneratingCode}
				inviteCode={inviteCode}
				providersWithCodes={providersWithCodes}
			/>
			<AboutModal
				isOpen={isAboutModalOpen}
				onClose={() => setAboutModalOpen(false)}
			/>
			<li className="dropdown dropdown-lg">
				<a
					href="#"
					className="dropdown-toggle"
					data-toggle="dropdown"
					role="button"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<img src={picPath} alt="Image" className="img-circle thumb32" />
					{name_first} {name_last}
					<span
						className={cn('circle', 'circle-lg', {
							'circle-success': connected,
							'circle-danger': !connected,
						})}
					/>
					<span className="caret"></span>
				</a>
				<ul className="dropdown-menu">
					<li>
						<Link to="profile">
							Edit Profile
							<div className="pull-right">
								<em className="icon-list" />
							</div>
						</Link>
					</li>
					<li role="separator" className="divider"></li>
					<li>
						<Link to="scheduling">
							Scheduling
							<div className="pull-right">
								<em className="icon-calendar" />
							</div>
						</Link>
					</li>
					<li>
						<Link to="settings">
							Practice Settings
							<div className="pull-right">
								<em className="icon-settings" />
							</div>
						</Link>
					</li>
					<li>
						<a href="#patient-invite" onClick={handleShowPatientInviteModal}>
							Invite Patient
							<div className="pull-right">
								<em className="icon-user-follow" />
							</div>
						</a>
					</li>
					<li role="separator" className="divider"></li>
					<li>
						<a href="mailto:support@careconvene.com">
							Support
							<div className="pull-right">
								<em className="icon-question" />
							</div>
						</a>
					</li>
					<li>
						<a
							href="https://ccpracticekb.helpsite.com/"
							target="_blank"
							rel="noreferrer"
						>
							Knowledge Base
							<div className="pull-right">
								<em className="icon-directions" />
							</div>
						</a>
					</li>
					<li role="separator" className="divider"></li>
					<li>
						<a href="#about" onClick={handleOpenAboutModal}>
							About
							<div className="pull-right">
								<em className="icon-info" />
							</div>
						</a>
					</li>
					<li role="separator" className="divider"></li>
					<li>
						<Link to="logout">
							Log Out
							<div className="pull-right">
								<em className="icon-logout" />
							</div>
						</Link>
					</li>
				</ul>
			</li>
		</>
	);
};

DropdownMenu.propTypes = {
	user: PropTypes.object.isRequired,
	appSocket: PropTypes.object.isRequired,
};

export default DropdownMenu;
